import _ from "lodash";
import convert from 'convert-length';
import {getNextItemKey} from "../../common/utils/item-key-util";
import {
    DEFAULT_SETTINGS,
    DESIGN_KEY_PREFIX,
    GRADIENT_POSITION_FIELD_LIST,
    RADIAL_GRADIENT_RADIUS_FIELD_LIST
} from "../constants/design.constant";
import {getColorHexCode} from "../../common/utils/color-util";

export {
    processBackgroundDetails,
    processVariantBackgroundDetails,
}

const processVariantBackgroundDetails = (designVariant) => {
    const settings = designVariant?.settings;
    const background = settings?.background;
    const colorKeyAttribute = 'backgroundColorKey';
    const colorCodeKeyAttribute = 'backgroundColorCodeKey';

    processBackgroundDetails(background, settings, colorKeyAttribute, colorCodeKeyAttribute);

    settings.background = background;
    designVariant.settings = settings;
}

const processBackgroundDetails = (background, settings, colorKeyAttribute?, colorCodeKeyAttribute?) => {
    if (_.isEmpty(background)) {
        return;
    }

    if (background?.colorType === 'solid') {
        background.backgroundColor = getColorHexCode(background, colorKeyAttribute, colorCodeKeyAttribute);
    } else if (background?.colorType === 'linear') {
        processLinearBackgroundDetails(background, settings);
    } else if (background?.colorType === 'radial') {
        processRadialBackgroundDetails(background, settings);
    }
}

const prepareDefaultValues = (background, fieldList) => {
    _.forEach(fieldList, field => {
        if (!background.hasOwnProperty(field?.attribute)) {
            background[field?.attribute] = field?.default;
        }
    });
}

const processLinearBackgroundDetails = (background, settings) => {
    const props: any = {};

    prepareDefaultValues(background, GRADIENT_POSITION_FIELD_LIST);

    props.fillLinearGradientStartPoint = preparePosition(background?.startPoint, settings);
    props.fillLinearGradientEndPoint = preparePosition(background?.endPoint, settings);
    props.fillLinearGradientColorStops = background.gradientColors || [];

    background.props = props;
}


const processRadialBackgroundDetails = (background, settings) => {
    const props: any = {};

    prepareDefaultValues(background, GRADIENT_POSITION_FIELD_LIST);
    prepareDefaultValues(background, RADIAL_GRADIENT_RADIUS_FIELD_LIST);

    props.fillRadialGradientStartPoint = preparePosition(background?.startPoint, settings);
    props.fillRadialGradientEndPoint = preparePosition(background?.endPoint, settings);
    props.fillRadialGradientStartRadius = settings.height * background?.startRadius / 100;
    props.fillRadialGradientEndRadius = settings.height * background?.endRadius / 100;
    props.fillRadialGradientColorStops = background.gradientColors || [];

    background.props = props;
}

const preparePosition = (startOrEndPoint, settings) => {
    let positionX = 0;
    let positionY = 0;

    switch (startOrEndPoint) {
        case 'left-top':
            positionX = 0;
            positionY = 0;
            break;
        case 'left-center':
            positionX = 0;
            positionY = settings?.height / 2;
            break;
        case 'left-bottom':
            positionX = 0;
            positionY = settings?.height;
            break;
        case 'right-top':
            positionX = settings?.width;
            positionY = 0;
            break;
        case 'right-center':
            positionX = settings?.width;
            positionY = settings?.height / 2;
            break;
        case 'right-bottom':
            positionX = settings?.width;
            positionY = settings?.height;
            break;
        case 'center-top':
            positionX = settings?.width / 2;
            positionY = 0;
            break;
        case 'center-center':
            positionX = settings?.width / 2;
            positionY = settings?.height / 2;
            break;
        case 'center-bottom':
            positionX = settings?.width / 2;
            positionY = settings?.height;
            break;
        default:
            positionX = 0;
            positionY = 0;
    }

    return {x: positionX, y: positionY};

}

